import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes/AppRoutes';
import SEO from './components/SEO';
import BlockedLayout from './components/blocked/BlockedLayout';
import { usePasswordProtection } from './hooks/usePasswordProtection';

function App() {
  const { isValidated } = usePasswordProtection();

  if (!isValidated) {
    return <BlockedLayout />;
  }

  return (
    <BrowserRouter>
      <ThemeProvider>
        <SEO />
        <AppRoutes />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;